export enum EmploymentType {
  Other = 'Other',
  EmploymentContract = 'EmploymentContract',
  MandateContract = 'MandateContract',
  Contract = 'Contract'
}
